"use client";

import { useEffect, useState } from "react";
import type { AgentClientFromBuild } from "@/agent/client/types";
import type { ClientBuild } from "@/exports/build/client";
import { useLifeClient } from "./provider";

interface UseAgentOptions {
  id?: string;
}

export function useAgent<K extends keyof ClientBuild>(
  name: K,
  options?: UseAgentOptions,
): AgentClientFromBuild<K> | null {
  const client = useLifeClient();
  const [agent, setAgent] = useState<AgentClientFromBuild<K> | null>(null);

  const initAgent = async () => {
    try {
      const instance = await client.getOrCreateAgent(name, options);
      setAgent(instance as unknown as AgentClientFromBuild<K>);
    } catch {
      setAgent(null); // Error is already logged by telemetry system.
    }
  };

  useEffect(() => {
    initAgent();
  }, [name, options]);

  return agent;
}
